/**
 * CompactInvitationSummary Component
 * Compact view showing stacked avatars, summary text, and edit action with chevron
 */

import { memo } from 'react';
import { IconChevronRight } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { StackedAvatars } from '../StackedAvatars';
import type { CompactInvitationSummaryProps } from '../../types';
import styles from './CompactInvitationSummary.module.css';

export const CompactInvitationSummary = memo(function CompactInvitationSummary({
  invitations,
  onExpand,
  disabled = false,
}: CompactInvitationSummaryProps) {
  const { t } = useTranslation();

  if (invitations.length === 0) {
    return null;
  }

  return (
    <button
      type="button"
      className={styles.container}
      onClick={onExpand}
      disabled={disabled}
    >
      <StackedAvatars invitations={invitations} />
      <span className={styles.summaryText}>
        {t('workspace.invitations.peopleInvited', {
          count: invitations.length,
        })}
      </span>
      <span className={styles.action}>
        {t('workspace.invitations.viewList')}
        <IconChevronRight size={14} className={styles.chevron} />
      </span>
    </button>
  );
});
